import { useRouter } from 'vue-router/composables';
import _ from 'lodash';
export const useDetailRouter = () => {
    const router = useRouter();
    /**
     * 更新数据源类型
     * @param dataType 数据源类型
     */
    const updateDataType = (dataType) => {
        router.replace({
            params: { dataType },
            query: {
                ..._.pick(router.currentRoute.query, ['spaceId', 'folderId']),
            },
        });
    };
    /**
     * 更新视图类型
     * @param viewType 视图类型
     */
    const updateViewType = (viewType) => {
        router.replace({
            params: { viewType },
            query: {
                ...router.currentRoute.query,
            },
        });
    };
    /**
     * 更新工作空间ID
     * @param spaceId 工作空间ID
     */
    const updateWorkspaceId = (spaceId) => {
        router.push({
            ...router.currentRoute,
            query: {
                spaceId,
            },
        });
    };
    /**
     * 更新文件夹ID
     * @param folderId 文件夹ID
     */
    const updateFolderId = (folderId) => {
        router.push({
            ...router.currentRoute,
            query: {
                ..._.pick(router.currentRoute.query, ['spaceId']),
                folderId,
            },
        });
    };
    /**
     * 更新过滤条件
     * @param cond 过滤条件
     */
    const updateCond = (cond) => {
        router.replace({
            query: {
                ...router.currentRoute.query,
                cond,
            },
        });
    };
    /**
     * 更新排序
     * @param sort 排序
     */
    const updateRouterSort = (sort) => {
        router.replace({ query: {
                ...router.currentRoute.query,
                sort,
            } });
    };
    /**
     * 更新页码
     * @param page 页码
     */
    const updatePage = (page) => {
        router.replace({ query: {
                ...router.currentRoute.query,
                page,
            } });
    };
    const refreshPage = () => {
        router.replace({ query: {
                ...router.currentRoute.query,
                _: Date.now().toString(),
            } });
    };
    const goToNoPermission = () => {
        router.replace({
            name: 'accessNoPermission',
            query: {
                ..._.pick(router.currentRoute.query, ['spaceId', 'folderId']),
            },
        });
    };
    const goToHome = () => {
        router.replace({
            name: 'home',
        });
    };
    return {
        updateWorkspaceId,
        updateFolderId,
        updateDataType,
        updateViewType,
        updateCond,
        updateRouterSort,
        updatePage,
        goToNoPermission,
        goToHome,
        refreshPage,
    };
};
